import { z } from "zod/v4";

/**
 * The cursor-paginated list envelope every keyset endpoint returns:
 * `nextCursor` is a string while more rows exist, `null` on the last page.
 * Clients must not build, parse or modify the cursor — copy it verbatim.
 */
export function cursorPageSchema<T extends z.ZodTypeAny>(item: T) {
	return z.object({
		items: z.array(item),
		nextCursor: z.string().nullable(),
	});
}

export type CursorPage<T> = { items: T[]; nextCursor: string | null };
